<script setup lang="ts">
import { computed } from "vue";
import { UIcon } from "#components";
import type { Portfolio } from "~/typings/portfolio";

interface TimelineExperienceIndicatorsProps {
  experience: Portfolio.Experience;

  class?: string;
}

const props = defineProps<TimelineExperienceIndicatorsProps>();

const isOngoing = computed(() => !props.experience.endDate);
const repository = computed(() => props.experience.repository);
const projectUrl = computed(() => props.experience.clientUrl);
const projectLabel = computed(
  () => props.experience.projectName || props.experience.company
);
</script>

<template>
  <div class="flex items-start pt-1 gap-2 shrink-0" :class="$props.class">
    <template v-if="isOngoing">
      <UiOngoingBadge v-if="isOngoing" variant="ongoing" />
    </template>
    <template v-else>
      <div>
        <span
          v-if="projectUrl"
          class="projectUrl-indicator inline-flex items-center justify-center rounded-full bg-primary-50 text-primary-700 transition-colors hover:text-primary-900 dark:bg-primary-900 dark:text-primary-200 dark:hover:text-primary-50"
          role="img"
          :aria-label="`Project available for ${projectLabel}`"
          :title="`Project available: ${projectLabel}`"
        >
          <UIcon
            name="i-heroicons-arrow-top-right-on-square-20-solid"
            :size="22"
            mode="svg"
          />
        </span>
      </div>
      <div>
        <span
          v-if="repository"
          class="repository-indicator inline-flex items-center justify-center rounded-full bg-primary-50 text-primary-700 transition-colors hover:text-primary-900 dark:bg-primary-900 dark:text-primary-200 dark:hover:text-primary-50"
          role="img"
          :aria-label="`Repository available for ${projectLabel}`"
          :title="`Repository available: ${repository.name}`"
        >
          <UIcon name="i-custom-github-fill" :size="22" mode="svg" />
        </span>
      </div>
    </template>
  </div>
</template>
